import { render } from "./MassUpdateEmailModal.vue?vue&type=template&id=c5552a16"
import script from "./MassUpdateEmailModal.vue?vue&type=script&lang=js"
export * from "./MassUpdateEmailModal.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\lenovo\\Desktop\\canadianlic\\client\\app\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__